<template>
  <v-app-bar v-if="isLoggedIn" app elevation="2" height="40" color="grey-lighten-2">
    <v-tabs class="ml-4">
      <v-tab
        v-for="tab in tabs"
        :key="tab.text"
        :to="tab.to"
        :text="tab.text"
        variant="plain"
        class="px-2 text-capitalize text-body-2"
      >
        {{ tab.text }}

        <template #append>
          <v-btn
            v-if="
              tab.id !== 0 &&
              !tab.to.includes('/task/approval') &&
              !tab.to.includes('/task/merging') &&
              !tab.to.includes('/task/transcription')
            "
            icon="mdi-close"
            size="x-small"
            class="ml-1"
            @click.prevent.stop="onRemoveTab(tab)"
          />
        </template>
      </v-tab>
    </v-tabs>

    <v-btn
      v-if="!isElectron"
      rounded
      size="small"
      variant="outlined"
      color="grey-darken-4"
      class="bg-grey-lighten-4 mr-2 ml-auto text-capitalize"
      prepend-icon="mdi-logout"
      @click="logoutConfirmationDialog = true"
    >
      Έξοδος
    </v-btn>

    <TheConfirmationDialog
      v-model="logoutConfirmationDialog"
      priorityToCancel
      title="Προειδοποίηση"
      message="Κλείσιμο Εφαρμογής"
      @cancel="logoutConfirmationDialog = false"
      @confirm="onLogout"
    />

    <TheConfirmationDialog
      v-model="logoutErrorDialog"
      priorityToCancel
      title="Προειδοποίηση"
      message="Παρουσιάστηκε σφάλμα κατά την αποσύνδεση. Θέλετε να τερματίσετε την εφαρμογή;"
      @cancel="logoutErrorDialog = false"
      @confirm="completeLogout"
    />
  </v-app-bar>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useNavTabsStore } from '@/stores/navTabs'
import { useTaskStore } from '@/stores/task'
import { useTapStore } from '@/stores/tap'
import TheConfirmationDialog from './TheConfirmationDialog.vue'

const route = useRoute()
const router = useRouter()

// * Tabs
const navTabsStore = useNavTabsStore()
const tabs = computed(() => navTabsStore.tabs)
const { removeTab } = navTabsStore

const taskStore = useTaskStore()

const onRemoveTab = (tab) => {
  removeTab(tab.id)

  if (tab.to === route.path) {
    router.push(tabs.value.at(-1).to)
  }
  if (tab.to.includes('/task/readonly/')) {
    taskStore.reset()
  }
}

// * Auth - IsLoggedIn
const authStore = useAuthStore()
const isLoggedIn = computed(() => {
  return authStore.isLoggedIn
})

// * Auth - Logout
const logoutConfirmationDialog = ref(false)
const tapStore = useTapStore()
const isElectron = typeof window !== 'undefined' && window.electron
const logoutErrorDialog = ref(false)

onMounted(() => {
  if (window.electron) {
    // Logout listener on app quit
    window.electron.ipcRenderer.on('logout', () => {
      authStore.logout().then(({ isSuccess }) => {
        if (isSuccess) {
          completeLogout()
        } else {
          // show error message
          logoutErrorDialog.value = true
        }
      })
    })
  }
})

const onLogout = async () => {
  const { isSuccess } = await authStore.logout()

  if (isSuccess) {
    completeLogout()
  } else {
    logoutErrorDialog.value = true
  }
}

const completeLogout = () => {
  authStore.reset()
  tapStore.reset()
  navTabsStore.reset()

  // send logout signal to electron main process
  if (window.electron) {
    window.electron.logoutComplete()
  }

  router.push('/')
}
</script>
